import React from 'react';
import {Box, Divider, Flex, Icon, Text} from '@chakra-ui/react';
import {FaCircle} from 'react-icons/fa';
import {format} from "date-fns";
import getPrettyStatus from "../../../../helpers/status";
import getPrettySyncStatus from "../../../../helpers/documentSyncStatus";

const StatusLogTimeline = ({statusLog}) => {
    // Combine both logs into one array
    const combinedLogs = [
        ...(statusLog || []).map(log => ({...log, status: getPrettyStatus(log.status)}))
    ];

    // Sort logs by timestamp in descending order (latest first)
    combinedLogs.sort((a, b) => a.timestamp - b.timestamp);

    if (combinedLogs.length === 0) {
        return (
            <Box p="4" bg="gray.50" borderRadius="md" textAlign="center">
                <Text color="gray.500">No status log available.</Text>
            </Box>
        );
    }

    return (
        <Box
            position="relative"
            p="4"
            bg="gray.50"
            borderRadius="md"
            overflowX="auto" // Enable horizontal scrolling
        >
            {/* Timeline Line */}
            <Divider
                orientation="horizontal"
                borderColor="blue.500"
                borderWidth="2px"
                position="absolute"
                top="50%"
                left="0"
                right="0"
                transform="translateY(-50%)"
                minWidth={`${combinedLogs.length * 200}px`} // Ensure the line spans the entire timeline
            />

            <Flex
                justify="flex-start" // Align items to the start for horizontal scrolling
                position="relative"
                minWidth={`${combinedLogs.length * 200}px`} // Ensure the Flex container spans the entire timeline
            >
                {combinedLogs.map((log, index) => (
                    <Box
                        key={log.id}
                        textAlign="center"
                        position="relative"
                        flex="0 0 200px" // Fixed width for each log entry
                    >
                        {/* Timeline Dot */}
                        <Box
                            position="absolute"
                            top="50%"
                            left="50%"
                            transform="translate(-50%, -50%)"
                            zIndex="1"
                        >
                            <Icon as={FaCircle} boxSize="12px" color="blue.500" bg="white" borderRadius="full"/>
                        </Box>

                        {/* Log Details */}
                        <Box mt="6" textAlign="center">
                            <Text fontWeight="bold" fontSize="xs">
                                {getPrettyStatus(log.status)}
                            </Text>
                            <Text fontSize="sm" color="gray.500" mt="3">
                                {format(new Date(log.timestamp), 'yyyy-MM-dd HH:mm')}
                            </Text>
                            {log.userName ? (
                                <Text fontSize="sm" color="gray.500">
                                    Utilizator: {log.userName}
                                </Text>
                            ) : <Text fontSize="sm" color="gray.500">Proces Automatizat</Text>
                            }
                        </Box>
                    </Box>
                ))}
            </Flex>
        </Box>
    );
};

export default StatusLogTimeline;